export default "__VITE_ASSET__C95wzPo7__"